const migrations: any = {};

export default migrations;
